// Keenthemes' plugins
window.KTUtil = require('../metronic/js/components/util.js');
window.KTCookie = require('../metronic/js/components/cookie.js');
window.KTMenu = require('../metronic/js/components/menu.js');
window.KTOffcanvas = require('../metronic/js/components/offcanvas.js');
window.KTScrolltop = require('../metronic/js/components/scrolltop.js');
window.KTToggle = require('../metronic/js/components/toggle.js');

// Metronic layout base js
window.KTLayoutAside = require('../metronic/js/layout/base/aside.js');
window.KTLayoutAsideMenu = require('../metronic/js/layout/base/aside-menu.js');
window.KTLayoutAsideToggle = require('../metronic/js/layout/base/aside-toggle.js');
window.KTLayoutBrand = require('../metronic/js/layout/base/brand.js');
window.KTLayoutContent = require('../metronic/js/layout/base/content.js');
window.KTLayoutFooter = require('../metronic/js/layout/base/footer.js');
window.KTLayoutHeader = require('../metronic/js/layout/base/header.js');
window.KTLayoutHeaderMenu = require('../metronic/js/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require('../metronic/js/layout/base/header-topbar.js');
window.KTLayoutStickyCard = require('../metronic/js/layout/base/sticky-card.js');
window.KTLayoutStretchedCard = require('../metronic/js/layout/base/stretched-card.js');
window.KTLayoutSubheader = require('../metronic/js/layout/base/subheader.js');
window.KTLayoutScrolltop = require('../metronic/js/layout/extended/scrolltop.js');

// Initialization
Bolt.on('load', () => {
    // Init Desktop & Mobile Headers
    if (typeof KTLayoutHeader !== 'undefined') {
        KTLayoutHeader.init('kt_header', 'kt_header_mobile');
    }

    // Init Header Menu
    if (typeof KTLayoutHeaderMenu !== 'undefined') {
        KTLayoutHeaderMenu.init('kt_header_menu', 'kt_header_menu_wrapper');
    }

    // Init Header Topbar For Mobile Mode
    if (typeof KTLayoutHeaderTopbar !== 'undefined') {
        KTLayoutHeaderTopbar.init('kt_header_mobile_topbar_toggle');
    }

    // Init Brand Panel For Logo
    if (typeof KTLayoutBrand !== 'undefined') {
        KTLayoutBrand.init('kt_brand');
    }

    // Init Aside
    if (typeof KTLayoutAside !== 'undefined') {
        KTLayoutAside.init('kt_aside');
    }

    // Init Aside Menu Toggle
    if (typeof KTLayoutAsideToggle !== 'undefined') {
        KTLayoutAsideToggle.init('kt_aside_toggle');
    }

    // Init Aside Menu
    if (typeof KTLayoutAsideMenu !== 'undefined') {
        KTLayoutAsideMenu.init('kt_aside_menu');
    }

    // Init Subheader
    if (typeof KTLayoutSubheader !== 'undefined') {
        KTLayoutSubheader.init('kt_subheader');
    }

    // Init Content
    if (typeof KTLayoutContent !== 'undefined') {
        KTLayoutContent.init('kt_content');
    }

    // Init Footer
    if (typeof KTLayoutFooter !== 'undefined') {
        KTLayoutFooter.init('kt_footer');
    }

    // Init Scrolltop
    if (typeof KTLayoutScrolltop !== 'undefined') {
        KTLayoutScrolltop.init('kt_scrolltop');
    }

    // Init Sticky Card
    if (typeof KTLayoutStickyCard !== 'undefined') {
        KTLayoutStickyCard.init('kt_page_sticky_card');
    }

    // Init Stretched Card
    if (typeof KTLayoutStretchedCard !== 'undefined') {
        KTLayoutStretchedCard.init('kt_page_stretched_card');
    }
});
